module.exports = __webpack_public_path__ + "static/img/m2.8fc9ba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m2.jpg
// module id = 1oJA
// module chunks = 1